import React from "react";
import Grid from "apollo-react/components/Grid";
import logo from "../../assets/images/logo2x.png";
import rightLowerBG from "../../assets/images/RightImg.png";
import "./style.css";

const AuthLayout = ({
  children,
  leftTitle = "Drug Registration System (D.R.S)",
  leftDescription =
    "IQVIA’s Drug Registration System (DRS) is a centralized, cloud-based platform designed to streamline the entire drug registration lifecycle—from submission to approval—while ensuring regulatory compliance and operational efficiency.",
  rightFooterText = "Copyright © 2024 IQVIA. All Rights Reserved.",
}) => {
  return (
    <Grid container style={{ height: "100vh" }}>
      {/* Left Half */}
      <Grid item xs={0} md={6} className="leftBG">
        <div className="overlay">
          <img src={logo} alt="IQVIA Logo" className="logo" />
          <div className="shapes">
            <div className="bigRectangle">
              <div className="textContainer">
                <h1 className="title">{leftTitle}</h1>
                <p className="description">{leftDescription}</p>
              </div>
            </div>
            <div className="smallRectangle"></div>
          </div>
        </div>
        <div className="footer">
          <img src={logo} alt="IQVIA Logo" className="footerLogo" />
          <ul className="footerLinks">
            <li>
              <a
                href="https://www.iqvia.com/about-us/terms-of-use"
                target="_blank"
                rel="noreferrer"
              >
                Terms of Use
              </a>
            </li>
            <li>
              <a
                href="https://www.iqvia.com/about-us/privacy/privacy-policy"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="mailto:eService@iqvia.com" target="_blank" rel="noreferrer">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </Grid>

      {/* Right Half */}
      <Grid
        container
        item
        xs={12}
        md={6}
        alignItems="center"
        justifyContent="center"
        className="rightBG"
      >
        <Grid
          item
          justifyContent="center"
          width="463px"
          position="relative"
          zIndex={1}
        >
          {children}
        </Grid>
        <img src={rightLowerBG} alt="Decorative" className="bottomRightImage" />
        <div className="rightFooter">{rightFooterText}</div>
      </Grid>
    </Grid>
  );
};

export default AuthLayout;


